import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'grape' | 'blush';
};
export const CHECKOUT_URL = 'https://the-menoreset-system.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'grape'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[65px] px-8 py-4 text-[18px]' : 'min-h-[58px] px-6 py-3.5 text-base';
  const skin = variant === 'blush' ? 'bg-blush-deep text-white shadow-[0_10px_36px_-12px_rgba(148,73,76,0.65)] ring-1 ring-blush-deep/40 hover:bg-plum hover:shadow-[0_16px_46px_-12px_rgba(148,73,76,0.8)] focus-visible:ring-plum' : 'bg-grape-soft text-plum-deep shadow-[0_10px_36px_-10px_rgba(223,151,151,0.85)] ring-1 ring-grape/30 hover:bg-grape hover:text-white hover:shadow-[0_16px_46px_-10px_rgba(168,90,90,0.75)] focus-visible:ring-plum';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href.startsWith('#')) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduce ? 'auto' : 'smooth',
      block: 'center'
    });
  };
  return <a href={href} onClick={handleClick} className={cn('group inline-flex w-full max-w-[340px] items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skin, pad, className)} style={{
    color: "#fffdfd"
  }} data-id="element-39" data-mp="1s6zbzutphr5k">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-40" data-mp="2b038dnyb6i3v" />
    </a>;
}